export function getdata() {
	var obj = {
		
			headDatavx: [
				// {
				// 	title: '操作',
				// 	prop: 'cz',
				// 	width: "100px",
				// 	custom: true,
				// },
				{
				title: "",
				prop: 'title',
				width: "",
				custom: true,
				},
				{
					
					title: "分支机构统一社会信用代码（纳税人识别号）",
					prop: 'sdsA_3_x_1',
					width: "120",
					custom: true,
				},
				{
					title: '分支机构名称',
					
					prop: 'sdsA_3_x_2',
					width: "",
					custom: true,
				},
				{
					title: "三项因素",
					children: [{
							title: "营业收入",
							prop: 'sdsA_3_x_3',
							
							width: "",
							custom: true,
						},
						{
							title: "职工薪酬",
							prop: 'sdsA_3_x_4',
							
							width: "",
							custom: true,
						},
						{
							title: "资产总额",
							prop: 'sdsA_3_x_5',
							
							width: "",
							custom: true,
						},
					]
				}, {
					title: '分配比例',
					prop: 'sdsA_3_x_6',
					
					width: "",
					custom: true,
				}, {
					title: '分支机构享受区域性优惠情况',
					prop: 'sdsA_3_x_7',
					width: "",
					custom: true,
				}, {
					title: '享受民族地方减免幅度',
					prop: 'sdsA_3_x_8',
					
					width: "",
					custom: true,
				}, {
					title: '享受民族地方优惠金额',
					prop: 'sdsA_3_x_9',
					
					width: "",
					custom: true,
				}, {
					title: '分配所得税额',
					prop: 'sdsA_3_x_10',
					
					width: "",
					custom: true,
				}
			],
			tableDatavx: [
			
			],
			headData: [{
					title: "应纳所得税额",
					prop: "sdsA_3_x_1",
					custom: true,
					width: ""
				}, {
					title: "总机构分摊所得税额",
					prop: "sdsA_3_x_2",
					width: "",
					custom: true,
				},
				{
					title: '总机构财政集中分配所得税额',
					prop: "sdsA_3_x_3",
					width: "",
					custom: true,
				},
				{
					title: "分支机构分摊所得税额",
					prop: "sdsA_3_x_4",
					width: "",
					custom: true,
		
				}
			],
			tableData: [{
				disabledsdsA_3_x_1: false,
				disabledsdsA_3_x_2: false,
				disabledsdsA_3_x_3: false,
				disabledsdsA_3_x_4: false,
				sdsA_3_x_1: {
					cellCode: "sdsA_3_1_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				sdsA_3_x_2: {
					cellCode: "sdsA_3_1_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				sdsA_3_x_3: {
					cellCode: "sdsA_3_1_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				sdsA_3_x_4: {
					cellCode: "sdsA_3_1_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
		
			}]
		
	}
	return obj
}
